import Backdrop, {BackdropProps} from '@mui/material/Backdrop';
import {styled} from '@mui/material/styles';

export const CBackdrop = styled(Backdrop)<BackdropProps>(
  (/* { theme } */) => ({
  }),
);
